export const SET_FORM = "SET_FORM";
export const SET_FORM_BY_URL = "SET_FORM_BY_URL";
export const RESET_FORM = "RESET_FORM";
